import { Box, Typography, Divider } from "@mui/material";
import { IPlanMetaDataProps } from "../types/interfaces/IPlanMetaDataProps";

//This component is responsible for rendering the plan name. 
const PlanMetaData: React.FC<IPlanMetaDataProps> = ({ plan }) => {

    const createAdvisorNameString = () => {
        const advisorCount = plan.LearnerAdvisors.length;

        if (advisorCount == 0) return;
        if (advisorCount == 1) return plan.LearnerAdvisors[0].FirstName + ' ' + plan.LearnerAdvisors[0].LastName;
        if (advisorCount > 1) {
            let advisorNameString = '';
            for (let i = 0; i < advisorCount; i++) {
                advisorNameString += plan.LearnerAdvisors[i].FirstName + ' ' + plan.LearnerAdvisors[i].LastName;
                if (i < advisorCount - 1) {
                    advisorNameString += ', ';
                }
            }
            return advisorNameString
        }
    };

    const formateDate = (stringDate: string) => {
        if (!stringDate) return;
        const date = new Date(stringDate);
        return date.toLocaleDateString()
    };

    return (
        <>
            <Box display="flex" alignItems="center" sx={{ mt: 5, mb: 1 }}>
                <Typography variant="h5" fontWeight="normal" color="black" mr={1}>
                    <b>Plan Name:</b> {plan.LearningPlan.PlanName}<br />
                    <b>Created by:</b> {plan.LearnerInfo.FirstName}  {plan.LearnerInfo.LastName}<br />
                    <b>Advisor(s):</b> {createAdvisorNameString()} <br />
                    <b>Plan Status:</b> {plan.LearningPlan.PlanStatus}<br />
                    <b>Created Date:</b> {formateDate(plan.LearningPlan.CreatedDate)}<br />
                    <b>Submitted Date:</b> {formateDate(plan.LearningPlan.SubmittedDate)}<br />
                    <b>Approved Date:</b> {formateDate(plan.LearningPlan.ApprovedDate)}
                </Typography>
            </Box>
            <Divider sx={{ mt: 1, mb: 2 }}></Divider>
        </>
    );
}

export default PlanMetaData;